import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from 'src/app/service/api.service';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatDatepickerInputEvent } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { Select2OptionData } from 'ng-select2';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { DataPassingService } from 'src/app/service/data-passing.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-student-payment',
  templateUrl: './student-payment.component.html',
  styleUrls: ['./student-payment.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class StudentPaymentComponent implements OnInit {

  branchName:string='';
  branchAddress:string='';
  isForm=true;
  isReceipt=false;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  name='';
  maxValid=false;
  maxDate=new Date();
  paymentModeList:Array<Select2OptionData>;
  constructor(private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datePipe:DatePipe,private dataPass:DataPassingService) {
    this.inputFormGroup=this.formBuilder.group({
      id:[''],
      name:[''],
      dueDate:['',Validators.required],
      scholarship:[''],
      paymentMode:['',Validators.required],
      reference:[''],
      bank:[''],
      loan_id:[''],
      remaining:[''],
      installment:[''],
      withdraw:['',[Validators.required,numValidation()]],
      note:['']
    });
   }

  ngOnInit() {
    this.branchName=localStorage.getItem('branchName');
    this.branchAddress=localStorage.getItem('branchAddress');
    this.paymentModeList=[];
    this.route.data.subscribe(data=>{
      data.feesPayment[0].data.forEach(element => {
        let aData={id:element.id,text:element.name};
        this.paymentModeList.push(aData);
      });
    },(error)=>{});

  }

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term => term.length<2 ?[''] :
        this.api.get("admission?search="+term).pipe(
          map((response)=>{if(response.status){
            return response.data.map((item,index)=>{
              let iamount=(parseInt(item.pending_amount)>parseInt(item.installments))?item.installments:item.pending_amount;
              return {name:item.registrationId,uname:item.name,display:item.name+"("+item.registrationId+")",id:item.id,scholarship:item.scholarship,remaining:item.pending_amount,installment:iamount,loan_id:item.loan_id};
            })
          }})
          )
      ),
      tap(() => this.searching = false)
    )

    formatter = (x: {name: string}) => x.name;
    rFormatter=(x: {display: string}) => x.display;

    selectedUser(item){
      this.inputFormGroup.patchValue({id:item.item.id,name:item.item.uname,loan_id:item.item.loan_id});

    }

    dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
      this.isDisabled=false;
      this.maxValid=false;
      let dt=event.value._d;
      let nwDt=new Date();
      if(dt>=nwDt)
      {
        this.isDisabled=true;
        this.maxValid=true;
       
        
      }
    }
   

  receiptNo(no)
  {
    let num=no.toString();
    if(num.length<2)
    {
      return '00'+num;
    }
    else if(num.length<3)
    {
      return '0'+num;
    }
    else
    {
      return num;
    }

  }

  changePage(event)
  {
    event.preventDefault();
    this.isForm=!this.isForm;
    this.isReceipt=!this.isReceipt;
  }

  paymentMode(event)
  {
   for(var i=0;i<this.paymentModeList.length;i++)
   {
     if(this.paymentModeList[i].id==event)
     {
       this.inputFormGroup.patchValue({paymentText:this.paymentModeList[i].text});
      
     }
     
   }
   
  }

  print()
  {
    window.print();
  }

  saveForm(form)
  {
    this.returnData=[];
    this.isError=false;
    this.isSuccess=false;
    this.isDisabled=true;
    this.isSubmitted=true;
    if(this.inputFormGroup.invalid)
    {
      this.isDisabled=false;
      return false;
    }
    else
    {
      form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
      this.api.post(form.value,'withdraw').subscribe(data=>{

        this.isSubmitted=false;
        this.isDisabled=false;
        this.inputFormGroup.reset();
        document.querySelector<HTMLInputElement>("#name").value='';
        alert(data.message);
      },(error)=>{});

    }
  }

  checkValue()
    {
      
      let paidAmount=this.inputFormGroup.controls.withdraw.value;
     
      if(parseInt(paidAmount)<10)
      {
        this.isGreater=true;
        this.isDisabled=true;
        
      }
      else
      {
       this.isGreater=false;
       this.isDisabled=false;
      }
  
    }
  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  convertNumberToWords(amount) {
    let words = new Array();
    words[0] = '';
    words[1] = 'One';
    words[2] = 'Two';
    words[3] = 'Three';
    words[4] = 'Four';
    words[5] = 'Five';
    words[6] = 'Six';
    words[7] = 'Seven';
    words[8] = 'Eight';
    words[9] = 'Nine';
    words[10] = 'Ten';
    words[11] = 'Eleven';
    words[12] = 'Twelve';
    words[13] = 'Thirteen';
    words[14] = 'Fourteen';
    words[15] = 'Fifteen';
    words[16] = 'Sixteen';
    words[17] = 'Seventeen';
    words[18] = 'Eighteen';
    words[19] = 'Nineteen';
    words[20] = 'Twenty';
    words[30] = 'Thirty';
    words[40] = 'Forty';
    words[50] = 'Fifty';
    words[60] = 'Sixty';
    words[70] = 'Seventy';
    words[80] = 'Eighty';
    words[90] = 'Ninety';
    amount = amount.toString();
    let atemp = amount.split(".");
    let number = atemp[0].split(",").join("");
    let n_length = number.length;
    let words_string = "";
    if (n_length <= 9) {
        let n_array = new Array(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let received_n_array = new Array();
        for (let i = 0; i < n_length; i++) {
            received_n_array[i] = number.substr(i, 1);
        }
        for (let i = 9 - n_length, j = 0; i < 9; i++, j++) {
            n_array[i] = received_n_array[j];
        }
        for (let i = 0, j = 1; i < 9; i++, j++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                if (n_array[i] == 1) {
                    n_array[j] = 10 + n_array[j];
                    n_array[i] = 0;
                }
            }
        }
        let value = 0;
        for (let i = 0; i < 9; i++) {
            if (i == 0 || i == 2 || i == 4 || i == 7) {
                value = n_array[i] * 10;
            } else {
                value = n_array[i];
            }
            if (value != 0) {
                words_string += words[value] + " ";
            }
            if ((i == 1 && value != 0) || (i == 0 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Crores ";
            }
            if ((i == 3 && value != 0) || (i == 2 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Lakhs ";
            }
            if ((i == 5 && value != 0) || (i == 4 && value != 0 && n_array[i + 1] == 0)) {
                words_string += "Thousand ";
            }
            if (i == 6 && value != 0 && (n_array[i + 1] != 0 && n_array[i + 2] != 0)) {
                words_string += "Hundred and ";
            } else if (i == 6 && value != 0) {
                words_string += "Hundred ";
            }
        }
        words_string = words_string.split("  ").join(" ");
    }
    return words_string;
  }

}
